import { Locale } from '@/types'

export const getLocales = () => Object.values(Locale)
export const getDefaultLocale = () => Locale.English
